import { render, staticRenderFns } from "./centerPay.vue?vue&type=template&id=248c1797&"
import script from "./centerPay.vue?vue&type=script&lang=js&"
export * from "./centerPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports